'use client';

import { usePathname } from 'next/navigation';
import { TopAlert } from './components/TopAlert';
import { Path } from '../../routes/components/path';

// Native top bar. The homepage renders its own notch-filling TopAlert inside its hero,
// so there is nothing to render here on the home route.
export const AppHeader: React.FC = () => {
  const pathname = usePathname();

  if (pathname === Path.Home) return null;

  return <TopAlert notchFill />;
};
